import css from 'styled-jsx/css'
import { colors, fonts, fontSizes, fontWeights } from 'theme'

export const sequentialDocuments = css`
  .sequential-documents .document-progress {
    margin: 1rem;
    text-align: center;
  }

  .sequential-documents .document-actions {
    width: 100%;
    max-width: 30rem;
    margin: 0.5rem auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  @media (max-width: 992px) {
    .document-progress {
      display: none;
    }

    .sequential-documents .document-actions :global(button.large.fullWidth.primary) {
      height: 2.375rem;
    }
  }
`

export const documentsCompletedStyles = css`
  .documents-completed {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 400px;
  }

  .completion-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 2rem 1rem;
  }

  .success-icon-wrapper {
    position: relative;
    margin-bottom: 2rem;
  }

  .success-icon-circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: ${colors.success};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px ${colors.alpha(colors.success, 0.3)};
    position: relative;
  }

  .success-icon-circle :global(.success-checkmark) {
    font-size: 60px;
    color: ${colors.white};
    font-weight: bold;
  }

  .completion-main-title {
    font-size: 2rem;
    font-weight: 700;
    color: ${colors.text};
    margin: 0 0 0.5rem 0;
  }

  .completion-message-box {
    background: ${colors.white};
    border-radius: 16px;
    padding: 2rem;
    box-shadow: 0 2px 8px ${colors.alpha(colors.black, 0.08)};
    border: 2px solid ${colors.border};
    max-width: 600px;
    width: 100%;
  }

  .message-item {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1.5rem;
    text-align: left;
    padding: 1rem;
    border-radius: 12px;
    background: ${colors.lightGray};
  }

  .message-item:last-child {
    margin-bottom: 0;
  }

  .message-icon {
    font-size: 1.5rem;
    flex-shrink: 0;
    line-height: 1;
    margin-top: 2px;
  }

  .message-item p {
    color: ${colors.text};
    font-size: 1rem;
    line-height: 1.6;
    margin: 0;
  }

  .message-item p strong {
    color: ${colors.primary};
    font-weight: 600;
  }

  .completion-actions {
    max-width: 400px;
    width: 100%;
    margin: 2rem 0;
    padding: 0 1rem;
  }

  .completion-actions :global(.button) {
    font-size: 1.125rem;
    font-weight: 600;
    padding: 1rem 2rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Processing Acceptance Styles */
  .processing-acceptance {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    text-align: center;
  }

  .processing-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

/* Acceptance Error Styles */
  .acceptance-error {
    text-align: center;
    padding: 60px 40px;
    margin: 40px;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .error-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .error-content :global(.ion-icon) {
    font-size: 48px;
    margin-bottom: 20px;
  }

  .error-content h2 {
    font-size: 28px;
    margin: 0 0 16px 0;
    font-weight: 600;
  }

  .error-content p {
    color: ${colors.lightText};
    font-size: 16px;
    margin: 0;
    line-height: 1.5;
    max-width: 400px;
  }

  .error-actions {
    max-width: 300px;
    width: 100%;
  }
`

export default css`
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.alpha(colors.black, 0.8)};
    z-index: 1050;
    visibility: hidden;
    opacity: 0;
    transition: opacity 300ms ease-in-out;
    pointer-events: none;
  }

  .fiscal-info-container :global(.modal) {
    width: 90%;
    max-width: 900px;
  }

  .fiscal-info-container.full-screen :global(.overlay) {
    padding: 0;
  }
  .fiscal-info-container.full-screen .fiscal-modal-container {
    height: 100vh;
    max-height: 100%;
    padding: 0;
  }

  .fiscal-info-container.full-screen .fiscal-modal-container :global(.sequential-documents),
  .fiscal-info-container.full-screen .fiscal-modal-container :global(.current-document),
  .fiscal-info-container.full-screen .fiscal-modal-container :global(.document-viewer),
  .fiscal-info-container.full-screen .fiscal-modal-container :global(.pdf-viewer-container) {
    height: 100%;
  }

  .fiscal-info-container.full-screen :global(.overlay .modal) {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    margin-top: 0;
    height: 100%;
    border-radius: 0;
  }
  
  .fiscal-info-container.full-screen :global(.modal .pdf-viewer-container) {
    margin: 0;
    max-width: 100%;
  }
  .modal-overlay.visible {
    visibility: visible;
    opacity: 1;
    pointer-events: all;
  }

  .fiscal-modal-container {
    max-height: 90vh;
    overflow-y: scroll;
    background: ${colors.white};
    border-radius: 8px;
    position: relative;
    z-index: 1051;
    padding: 2rem;
  }

  .fiscal-modal-container.has-documents {
    padding: 0;
  }

  .fiscal-modal-container.generation-loading {
    overflow: hidden;
    scroll-behavior: none;
  }
    

  .modal-header {
    text-align: center;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${colors.border};
  }

  .modal-header h2 {
    font: ${fonts.bold};
    font-size: ${fontSizes.h3};
    color: ${colors.text};
    margin: 0 0 0.5rem 0;
  }

  .modal-header-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-right: 1rem;
    gap: 1rem;
    align-items: flex-end;
  }
  .modal-header-content :global(.tracing-tour-container) {
    margin-bottom: 0;
  }

  .modal-subtitle {
    font: ${fonts.regular};
    font-size: ${fontSizes.body};
    color: ${colors.text};
    margin: 0;
  }

  .fiscal-form {
    width: 100%;
  }

  .form-content {
    margin-bottom: 2rem;
  }

  .form-content :global(.form-input-margin) {
    margin-bottom: 1.5rem;
  }

  .beneficiaries-container {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid ${colors.border};
  }

  .beneficiaries-header {
    margin-bottom: 1.5rem;
  }

  .beneficiaries-title {
    display: flex;
    justify-content: space-between;
  }

  .beneficiaries-header h4 {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.h4};
    color: ${colors.text};
    margin: 0 0 0.5rem 0;
  }

  .beneficiaries-subtitle {
    font: ${fonts.regular};
    font-size: ${fontSizes.small};
    color: ${colors.text};
    margin: 0;
  }

  .beneficiaries-error {
    font: ${fonts.medium};
    font-size: ${fontSizes.small};
    color: ${colors.danger};
    display: block;
    margin-top: 0.5rem;
  }

  .beneficiaries-content {
    margin-bottom: 1rem;
  }

  .beneficiary-group {
    margin-bottom: 2rem;
    padding: 1.5rem;
    background-color: ${colors.lightGray};
    border-radius: 8px;
    border: 1px solid ${colors.border};
    position: relative;
  }

  .beneficiary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${colors.borderInput};
  }

  .beneficiary-header h5 {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.h5};
    color: ${colors.text};
    margin: 0;
  }

  .remove-beneficiary-btn {
    background: ${colors.danger};
    color: ${colors.white};
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: ${fontSizes.body};
  }

  .remove-beneficiary-btn:hover {
    background: ${colors.alpha(colors.danger, 0.8)};
    transform: scale(1.1);
  }

  .beneficiary-errors {
    margin-top: 1rem;
    padding: 1rem;
    background-color: ${colors.alpha(colors.danger, 0.1)};
    border-radius: 4px;
    border-left: 4px solid ${colors.danger};
  }

  .beneficiary-field-error {
    display: block;
    font: ${fonts.medium};
    font-size: ${fontSizes.small};
    color: ${colors.danger};
    margin-bottom: 0.25rem;
  }

  .beneficiary-field-error:last-child {
    margin-bottom: 0;
  }

  .add-beneficiary-container {
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;
  }

  .add-beneficiary-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    font: ${fonts.medium};
    font-size: ${fontSizes.body};
  }

  .add-beneficiary-btn :global(.ion-icon) {
    font-size: ${fontSizes.h5};
  }

  .beneficiary-group h5 {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.h5};
    color: ${colors.text};
    margin: 0 0 1rem 0;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${colors.borderInput};
  }

  .modal-actions {
    padding-top: 2rem;
    border-top: 1px solid ${colors.border};
  }

  .modal-actions :global(.button) {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.body};
    padding: 1rem 2rem;
  }

  /* Responsive design */

  /* Desktop: Show desktop button, hide mobile button */
  @media (min-width: 1024px) {
    button#fiscal-logout-button-mobile {
      display: none !important;
    }

    button#fiscal-logout-button-desktop {
      display: block !important;
    }
  }

  /* Mobile/Tablet: Show mobile button, hide desktop button */
  @media (max-width: 1023px) {
    #fiscal-logout-button-mobile {
      display: block !important;
    }

    #fiscal-logout-button-desktop {
      display: none !important;
    }
  }

  @media (max-width: 992px) {
    .fiscal-info-container :global(.modal) {
      width: 100%;
    }

    .fiscal-info-container :global(.overlay) {
      padding: 0.5rem;
    }

    .beneficiaries-header {
      padding: 0 0.5rem;
    }
    
    .fiscal-info-container :global(.modal .fiscal-modal-container) {
      padding: 0.5rem 0;
    }

    .fiscal-info-container :global(.modal .fiscal-modal-container .fiscal-form .fiscal-form-row) {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }

  @media (max-width: 768px) {
    .fiscal-info-container.full-screen .fiscal-modal-container {
      height: 100%;
    }
    .fiscal-modal-container {
      padding: 1rem;
      max-height: 90dvh;
      overflow-y: scroll;
    }

    .modal-header h2 {
      font-size: ${fontSizes.h4};
    }

    .beneficiary-group {
      padding: 1rem;
    }

    .remove-beneficiary-btn {
      width: 28px;
      height: 28px;
      font-size: ${fontSizes.small};
    }

    .add-beneficiary-btn {
      padding: 0.5rem 1rem;
      font-size: ${fontSizes.small};
    }
  }

  @media (max-width: 548px) {
    .fiscal-info-container :global(.overlay) {
      padding: 0;
    }
  }

  @media (max-width: 480px) {
    .modal-header {
      margin-bottom: 1.5rem;
    }

    .form-content :global(.form-input-margin) {
      margin-bottom: 1rem;
    }

    .beneficiaries-container {
      margin-top: 1.5rem;
      padding-top: 1.5rem;
    }

    .beneficiary-group {
      margin-bottom: 1.5rem;
      padding: 0.75rem;
    }

    .beneficiary-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .remove-beneficiary-btn {
      align-self: flex-end;
    }
  }

  /* Documents Section Styles */
  .documents-section {
    padding: 30px;
  }

  .documents-section h4 {
    color: ${colors.primary};
    font-size: 20px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .documents-subtitle {
    color: ${colors.lightText};
    font-size: 14px;
    margin-bottom: 24px;
    line-height: 1.5;
  }

  .documents-list {
    background: ${colors.lightGray};
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
  }

  .document-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: ${colors.white};
    border-radius: 6px;
    border: 1px solid ${colors.border};
    margin-bottom: 12px;
    transition: all 0.2s ease;
  }

  .document-item:last-child {
    margin-bottom: 0;
  }

  .document-item:hover {
    border-color: ${colors.primary};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .document-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .document-info :global(.ion-icon) {
    font-size: 20px;
    color: ${colors.primary};
  }

  .document-name {
    font-weight: 500;
    color: ${colors.text};
    font-size: 15px;
  }

  .document-actions {
    display: flex;
    gap: 8px;
  }

  .documents-actions {
    border-top: 1px solid ${colors.border};
    padding-top: 20px;
  }

  @media (max-width: 768px) {
    .document-item {
      flex-direction: column;
      gap: 12px;
      align-items: flex-start;
    }

    .document-actions {
      width: 100%;
      justify-content: flex-end;
    }

    .documents-section {
      padding: 20px;
    }
  }

  /* Sequential Documents Styles */
  .sequential-documents {
    padding: 30px;
  }

  .progress-counter {
    color: ${colors.lightText};
    font-size: 14px;
    font-weight: 500;
    display: block;
    margin-bottom: 12px;
  }

  .progress-bar {
    width: 100%;
    height: 8px;
    background-color: ${colors.lightGray};
    border-radius: 4px;
    overflow: hidden;
  }

  .progress-fill {
    height: 100%;
    background-color: ${colors.primary};
    transition: width 0.3s ease;
  }

  .current-document {
    background-color: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }

  .document-viewer {
    min-height: 500px;
    max-height: 700px;
    overflow: hidden;
  }

  .document-actions {
    padding: 24px;
    background-color: ${colors.lightGray};
    margin-top: 1rem;
  }

  .document-actions :global(.button) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    padding: 14px 24px;
  }

  .document-actions :global(.ion-icon) {
    font-size: 20px;
  }

  /* Documents Completed Styles */
  .documents-completed {
    text-align: center;
    padding: 80px 40px;
    background-color: ${colors.alpha(colors.success || colors.primary, 0.05)};
    border: 1px solid ${colors.alpha(colors.success || colors.primary, 0.2)};
    border-radius: 16px;
    margin: 40px;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 5;
  }

  .completion-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
  }

  .completion-content h2 {
    color: ${colors.primary};
    font-size: 36px;
    margin: 0 0 20px 0;
    font-weight: 700;
    font-family: ${fonts.display || fonts.regular};
  }

  .completion-content p {
    color: ${colors.lightText};
    font-size: 18px;
    margin: 0;
    line-height: 1.5;
    max-width: 500px;
  }

  .completion-actions {
    max-width: 350px;
    width: 100%;
    position: relative;
    z-index: 10;
  }

  .completion-actions :global(.button) {
    position: relative;
    z-index: 11;
    pointer-events: auto;
    cursor: pointer;
  }

  .processing-message {
    margin-top: 20px;
  }

  .processing-message p {
    color: ${colors.lightText};
    font-size: 16px;
    margin: 0;
    font-style: italic;
  }

  /* Processing Acceptance Styles */
  .processing-acceptance {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    text-align: center;
  }

  .processing-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .processing-content h2 {
    color: ${colors.primary};
    font-size: 28px;
    margin: 0;
    font-weight: 600;
  }

  .processing-content p {
    color: ${colors.lightText};
    font-size: 16px;
    margin: 0;
    line-height: 1.5;
    max-width: 400px;
  }

  /* Document Actions Loading States */
  .document-actions :global(.button:disabled) {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .document-actions :global(.button .spinner) {
    margin-right: 8px;
  }

  .generation-loading-content {
    text-align: center;
    padding: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .generation-loading-content h3 {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.h4};
    color: ${colors.primary};
    margin: 20px 0 16px 0;
  }

  .generation-loading-content p {
    font: ${fonts.regular};
    font-size: ${fontSizes.body};
    color: ${colors.lightText};
    margin: 0;
    line-height: 1.5;
  }

  /* Acceptance Error Styles */
  .acceptance-error {
    text-align: center;
    padding: 60px 40px;
    background-color: ${colors.alpha(colors.danger || colors.red, 0.05)};
    border: 1px solid ${colors.alpha(colors.danger || colors.red, 0.2)};
    border-radius: 16px;
    margin: 40px;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .error-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .error-content :global(.ion-icon) {
    font-size: 48px;
    color: ${colors.danger || colors.red};
    margin-bottom: 20px;
  }

  .error-content h2 {
    color: ${colors.danger || colors.red};
    font-size: 28px;
    margin: 0 0 16px 0;
    font-weight: 600;
  }

  .error-content p {
    color: ${colors.lightText};
    font-size: 16px;
    margin: 0;
    line-height: 1.5;
    max-width: 400px;
  }

  .error-actions {
    max-width: 300px;
    width: 100%;
  }

  @media (max-width: 768px) {
    .acceptance-error {
      padding: 40px 20px;
      margin: 20px;
      min-height: 250px;
    }

    .error-content h2 {
      font-size: 24px;
    }

    .error-content :global(.ion-icon) {
      font-size: 40px;
    }

    .document-progress {
      display: none;
    }

    .completion-main-title {
      font-size: 1.5rem;
    }

    .success-icon-circle {
      width: 80px;
      height: 80px;
    }

    .success-icon-circle :global(.success-checkmark) {
      font-size: 48px;
    }

    .completion-message-box {
      padding: 1.5rem;
    }

    .message-item {
      padding: 0.75rem;
      gap: 0.75rem;
    }

    .message-icon {
      font-size: 1.25rem;
    }

    .message-item p {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 768px) {
    .sequential-documents {
      padding: 20px;
    }

    .document-header {
      padding: 20px 16px;
    }

    .document-actions {
      padding: 20px 16px;
    }

    .documents-completed {
      padding: 40px 20px;
      margin: 20px;
      min-height: 300px;
    }

    .completion-content {
      padding: 1rem 0.5rem;
    }

    .completion-header :global(.ion-icon) {
      font-size: 48px;
    }
  }

  /* Percentage Indicator Styles */
  .percentage-indicator {
    text-align: center;
    margin: 15px 0;
    padding: 10px;
    border-radius: 4px;
    background-color: ${colors.lightGray};
  }

  .percentage-total {
    font-weight: 600;
    font-size: 14px;
  }

  .percentage-total.valid {
    color: ${colors.success};
  }

  .percentage-total.invalid {
    color: ${colors.danger};
  }

  /* Field Error Styles */
  .field-error {
    color: ${colors.danger};
    font-size: 12px;
    margin-top: 4px;
    font-weight: 500;
  }

  /* Form Errors Styles */
  .form-errors {
    margin: 15px 0;
    padding: 12px;
    background-color: ${colors.alpha(colors.danger, 0.1)};
    border: 1px solid ${colors.danger};
    border-radius: 4px;
    color: ${colors.danger};
  }

  .form-error {
    margin-bottom: 5px;
    font-size: 14px;
  }

  .form-error:last-child {
    margin-bottom: 0;
  }

  /* External logout button container */
  .external-logout-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 99999; /* Very high z-index */
    background: rgba(255, 255, 255, 0.9);
    padding: 8px;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }

  @media screen and (max-width: 768px) {
    .external-logout-container {
      top: 10px;
      right: 10px;
    }
  }

  /* Custom modal positioning for fiscal info modal */
  :global(.fiscal-info-modal .overlay.top .modal) {
    margin-top: 3.5rem !important;
  }
`
